import { toast } from "react-toastify";

// const API_BASE_URL = "http://16.171.2.24/api";
// const API_BASE_URL = "http://localhost:8080/api";
const API_BASE_URL = "https://api.savealifemine.com/api";


const getHeaders = () => ({
  "Content-Type": "application/json",
});

const handleApiResponse = async (response) => {
  const data = await response.json();

  // if (response.status === 401) {
  //   console.log("Unauthorized. Redirecting to login...");

  //   localStorage.removeItem("authToken");
  //   localStorage.removeItem("selectedPackageId");
  //   localStorage.removeItem("isCardSaved");

  //   if (window.location.pathname !== "/login") {
  //     window.location.href = "/login";
  //   }

  //   return data;
  // }
  if (!response.ok) {
    // Log the full error response for debugging
    // console.error("API Error Response:", {
    //   status: response.status,
    //   statusText: response.statusText,
    //   data: data,
    // });

    // If there are validation errors, include them in the error message
    if (data.errors && Array.isArray(data.errors)) {
      // throw new Error(`Validation error: ${data.errors.join(", ")}`);
      if (data.errors && Array.isArray(data.errors)) {
        data.errors.forEach((error) => {
          toast.error(error);
        });
      }
    }

    throw new Error(data.message ?? data.error ?? "Something went wrong!");
  }
  console.log("API Response Data:", data);
  return data;
};

export const uploadImage = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(`${API_BASE_URL}/patients/upload/file`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Image upload failed");
    }
    return data;
  } catch (error) {
    console.error("Image upload error:", error);
    throw error;
  }
};

// Login API function
export const loginUser = async (loginData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(loginData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

// Signup API function
export const signupUser = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/signup`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(userData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Signup error:", error);
    throw error;
  }
};

// Verify Email API function
export const verifyEmail = async (verificationData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/verify-email`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(verificationData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Email verification error:", error);
    throw error;
  }
};

// Resend Verification Code API function
export const resendVerificationCode = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/resend-verification`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ email }),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Resend verification code error:", error);
    throw error;
  }
};

// Verify OTP API function
export const verifyOtp = async (otp, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/auth/verify-otp`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ otp }),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("OTP verification error:", error);
    throw error;
  }
};

// Request OTP Again API function
export const resendOtp = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/auth/resend-otp`, {
      method: "POST",
      headers: headers,
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Request OTP error:", error);
    throw error;
  }
};

// Create Card API function
export const createPatientCard = async (cardData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/create-card`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(cardData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Create card error:", error);
    throw error;
  }
};

// Generate QR Code API function
export const FetchQRCode = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/qr-code`, {
      method: "GET",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Generate QR code error:", error);
    throw error;
  }
};

export const generateQRCode = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/qr-code`, {
      method: "POST",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Generate QR code error:", error);
    throw error;
  }
};

// Get Patient Card API function
export const getPatientCard = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/card`, {
      method: "GET",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get patient card error:", error);
    throw error;
  }
};

// Get Account Details API function
export const getAccountDetails = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/account`, {
      method: "GET",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get account details error:", error);
    throw error;
  }
};

// Update Account API function
export const updateAccount = async (accountData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/account`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(accountData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update account error:", error);
    throw error;
  }
};

// Change Password API function
export const changePassword = async (passwordData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/account/password`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(passwordData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Change password error:", error);
    throw error;
  }
};

// Get Contact Info API function
export const getContactInfo = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/contact`, {
      method: "GET",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get contact info error:", error);
    throw error;
  }
};

// Update Contact Info API function
export const updateContactInfo = async (contactData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/contact`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(contactData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update contact info error:", error);
    throw error;
  }
};

// Get Profile API function
export const getProfile = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/profile`, {
      method: "GET",
      headers: headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get profile error:", error);
    throw error;
  }
};

// Update Profile API function
export const updateProfile = async (profileData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    console.log("Updating profile with data:", profileData);
    const response = await fetch(`${API_BASE_URL}/patients/profile`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(profileData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update profile error:", error);
    throw error;
  }
};

// Upload Profile Picture API function
export const uploadProfilePicture = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append("profilePicture", file);

    const response = await fetch(`${API_BASE_URL}/patients/profile-picture`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type header - let browser set it with boundary for FormData
      },
      body: formData,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Upload profile picture error:", error);
    throw error;
  }
};

// Get Medications API function
export const getMedications = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/medications`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get medications error:", error);
    throw error;
  }
};

// Add Medication API function
export const addMedication = async (medicationData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/medications`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(medicationData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add medication error:", error);
    throw error;
  }
};

// Update Medication API function
export const updateMedication = async (medicationId, medicationData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medications/${medicationId}`,
      {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(medicationData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update medication error:", error);
    throw error;
  }
};

// Delete Medication API function
export const deleteMedication = async (medicationId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medications/${medicationId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete medication error:", error);
    throw error;
  }
};

// Get Allergies API function
export const getAllergies = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/allergies`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get allergies error:", error);
    throw error;
  }
};

// Add Allergy API function
export const addAllergy = async (allergyData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/allergies`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(allergyData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add allergy error:", error);
    throw error;
  }
};

// Update Allergy API function
export const updateAllergy = async (allergyId, allergyData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/allergies/${allergyId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(allergyData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Update allergy error:", error);
    throw error;
  }
};

// Delete Allergy API function
export const deleteAllergy = async (allergyId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/allergies/${allergyId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete allergy error:", error);
    throw error;
  }
};

// Get Medical Procedures API function
export const getMedicalProcedures = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-procedures`,
      {
        method: "GET",
        headers: headers,
      },
    );

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get medical procedures error:", error);
    throw error;
  }
};

// Add Medical Procedure API function
export const addMedicalProcedure = async (procedureData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-procedures`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(procedureData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add medical procedure error:", error);
    throw error;
  }
};

// Update Medical Procedure API function
export const updateMedicalProcedure = async (
  procedureId,
  procedureData,
  token,
) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/medical-procedures/${procedureId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(procedureData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Update medical procedure error:", error);
    throw error;
  }
};

// Delete Medical Procedure API function
export const deleteMedicalProcedure = async (procedureId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-procedures/${procedureId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete medical procedure error:", error);
    throw error;
  }
};

// Get Family History API function
export const getFamilyHistory = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/family-history`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get family history error:", error);
    throw error;
  }
};

// Add Family History API function
export const addFamilyHistory = async (familyHistoryData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/family-history`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(familyHistoryData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add family history error:", error);
    throw error;
  }
};

// Update Family History API function
export const updateFamilyHistory = async (
  familyHistoryId,
  familyHistoryData,
  token,
) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/family-history/${familyHistoryId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(familyHistoryData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Update family history error:", error);
    throw error;
  }
};

// Delete Family History API function
export const deleteFamilyHistory = async (familyHistoryId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/family-history/${familyHistoryId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete family history error:", error);
    throw error;
  }
};

// Get Lifestyle Info API function
export const getLifestyleInfo = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/lifestyle`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get lifestyle info error:", error);
    throw error;
  }
};

// Add Lifestyle Info API function
export const addLifestyleInfo = async (lifestyleData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/lifestyle`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(lifestyleData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add lifestyle info error:", error);
    throw error;
  }
};

// Update Lifestyle Info API function
export const updateLifestyleInfo = async (lifestyleData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/lifestyle`, {
      method: "PUT",
      body: JSON.stringify(lifestyleData),
      headers,
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update lifestyle info error:", error);
    throw error;
  }
};

// --- Stripe / Subscription APIs ---

export const getStripeAccessStatus = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/get-access`, {
      method: "GET",
      headers: headers,
    });
    return handleApiResponse(response);
  } catch (error) {
    console.error("Get stripe access status error:", error);
    throw error;
  }
};

export const getSubscriptionPackages = async () => {
  try {
    const headers = {
      ...getHeaders(),
    };
    const response = await fetch(`${API_BASE_URL}/stripe/subscription`, {
      method: "GET",
      headers: headers,
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get subscription packages error:", error);
    throw error;
  }
};

export const authorizeStripeCard = async (paymentMethodData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/authorize`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(paymentMethodData),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Authorize stripe card error:", error);
    throw error;
  }
};

export const getStripeCardDetails = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/get-details`, {
      method: "GET",
      headers: headers,
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get stripe card details error:", error);
    throw error;
  }
};

export const deleteStripeCard = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/delete-card`, {
      method: "POST",
      headers: headers,
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete stripe card error:", error);
    throw error;
  }
};

export const createStripeSubscription = async (subscriptionData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/create-subscription`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(subscriptionData),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Create stripe subscription error:", error);
    throw error;
  }
};

export const getStripeSubscriptionHistory = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/get-history`, {
      method: "GET",
      headers: headers,
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Get stripe subscription history error:", error);
    throw error;
  }
};

export const cancelStripeSubscription = async (subscriptionId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${API_BASE_URL}/stripe/cancel-subscription`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ subscriptionId }),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Cancel stripe subscription error:", error);
    throw error;
  }
};

// ------------------------- stripe apis end ----------------------------

// Get Doctors API function
export const getDoctors = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/doctors`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get doctors error:", error);
    throw error;
  }
};

// Add Doctor API function
export const addDoctor = async (doctorData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/doctors`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(doctorData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add doctor error:", error);
    throw error;
  }
};

// Update Doctor API function
export const updateDoctor = async (doctorId, doctorData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/doctors/${doctorId}`,
      {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(doctorData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update doctor error:", error);
    throw error;
  }
};

// Delete Doctor API function
export const deleteDoctor = async (doctorId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/doctors/${doctorId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete doctor error:", error);
    throw error;
  }
};

// Get Hospitals API function
export const getHospitals = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/hospitals`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get hospitals error:", error);
    throw error;
  }
};

// Add Hospital API function
export const addHospital = async (hospitalData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/hospitals`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(hospitalData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add hospital error:", error);
    throw error;
  }
};

// Update Hospital API function
export const updateHospital = async (hospitalId, hospitalData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/hospitals/${hospitalId}`,
      {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(hospitalData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update hospital error:", error);
    throw error;
  }
};

// Delete Hospital API function
export const deleteHospital = async (hospitalId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/hospitals/${hospitalId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete hospital error:", error);
    throw error;
  }
};

// Get Medical Conditions API function
export const getMedicalConditions = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-conditions`,
      {
        method: "GET",
        headers: headers,
      },
    );

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get medical conditions error:", error);
    throw error;
  }
};

// Add Medical Condition API function
export const addMedicalCondition = async (conditionData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-conditions`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(conditionData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add medical condition error:", error);
    throw error;
  }
};

// Update Medical Condition API function
export const updateMedicalCondition = async (
  conditionId,
  conditionData,
  token,
) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/medical-conditions/${conditionId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(conditionData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Update medical condition error:", error);
    throw error;
  }
};

// Delete Medical Condition API function
export const deleteMedicalCondition = async (conditionId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-conditions/${conditionId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete medical condition error:", error);
    throw error;
  }
};

// Get Therapies API function
export const getTherapies = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/therapies`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get therapies error:", error);
    throw error;
  }
};

// Add Therapy API function
export const addTherapy = async (therapyData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/therapies`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(therapyData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add therapy error:", error);
    throw error;
  }
};

// Update Therapy API function
export const updateTherapy = async (therapyId, therapyData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/therapies/${therapyId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(therapyData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Update therapy error:", error);
    throw error;
  }
};

// Delete Therapy API function
export const deleteTherapy = async (therapyId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/therapies/${therapyId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete therapy error:", error);
    throw error;
  }
};

// Get Medical Devices API function
export const getMedicalDevices = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/medical-devices`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get medical devices error:", error);
    throw error;
  }
};

// Add Medical Device API function
export const addMedicalDevice = async (deviceData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/medical-devices`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(deviceData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add medical device error:", error);
    throw error;
  }
};

// Update Medical Device API function
export const updateMedicalDevice = async (deviceId, deviceData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const url = `${API_BASE_URL}/patients/medical-devices/${deviceId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(deviceData),
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    throw error;
  }
};

// Delete Medical Device API function
export const deleteMedicalDevice = async (deviceId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/patients/medical-devices/${deviceId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete medical device error:", error);
    throw error;
  }
};

// Get Patients API function (for doctors)
export const getPatients = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/doctors/patients`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get patients error:", error);
    throw error;
  }
};

// Add Patient API function (for doctors)
export const addPatient = async (patientData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    // Log the data being sent for debugging

    const response = await fetch(`${API_BASE_URL}/doctors/patients`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(patientData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Add patient error:", error);
    throw error;
  }
};

// Update Patient API function (for doctors)
export const updatePatient = async (patientId, patientData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/doctors/patients/${patientId}`,
      {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(patientData),
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update patient error:", error);
    throw error;
  }
};

// Delete Patient API function (for doctors)
export const deletePatient = async (patientId, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${API_BASE_URL}/doctors/patients/${patientId}`,
      {
        method: "DELETE",
        headers: headers,
      },
    );

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Delete patient error:", error);
    throw error;
  }
};

// Get Insurance API function
export const getInsurance = async (token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/profile`, {
      method: "GET",
      headers: headers,
    });

    const result = await handleApiResponse(response);
    return result;
  } catch (error) {
    console.error("Get insurance error:", error);
    throw error;
  }
};

// Update Insurance API function
export const updateInsurance = async (insuranceData, token) => {
  try {
    const headers = {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE_URL}/patients/profile`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(insuranceData),
    });

    return await handleApiResponse(response);
  } catch (error) {
    console.error("Update insurance error:", error);
    throw error;
  }
};

// Forgot Password API function
export const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ email }),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Forgot password error:", error);
    throw error;
  }
};

// Reset Password API function
export const resetPassword = async (token, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ token, password }),
    });
    return await handleApiResponse(response);
  } catch (error) {
    console.error("Reset password error:", error);
    throw error;
  }
};

// Export the base URL for use in other files if needed
export { API_BASE_URL };
